export const data = {
    experience: [
      {
        title: "Consultant",
        subTitle: "Miami, FL",
        description: "User Experience, Visual Design",
        date: "2020 - Present"
      },
      // {
      //   title: "Senior Consultant",
      //   subTitle: "London, UK",
      //   description: "Web development, Databases, Backend development",
      //   date: "2019 - 2020"
      // },
      // {
      //   title: "Project Manager",
      //   subTitle: "Bangalore, INDIA",
      //   description: "Creative Direction Project Management, Team Leading",
      //   date: "2018 - 2019"
      // },
    ],
    education: [
       {
        title: "B.Tech in Computer Science & Engineering",
        subTitle: "University of Engineering & Management Jaipur",
        description: "CGPA: 8.00",
        date: "2022 - 2026"
      },
      {
        title: "Higher Secondary",
        subTitle: "Asian School",
        description: " 75.60%",
        date: "2021 - 2022"
      },
      {
        title: "Secondary",
        subTitle: "Asian School",
        description: "83.84%",
        date: "2019 - 2020"
      },
    ],
  };